import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { CtaLinkComponent } from './cta-link.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		RouterModule,
		AnalyticsModule,
		CwpNgFrameworkModule,
		GenericDirectivesModule
	],
	declarations: [CtaLinkComponent],
	exports: [CtaLinkComponent]
})
export class CtaLinkModule { }
